import { render, staticRenderFns } from "./ModelliEmail.vue?vue&type=template&id=7c9c18e4&scoped=true&"
import script from "./ModelliEmail.vue?vue&type=script&lang=js&"
export * from "./ModelliEmail.vue?vue&type=script&lang=js&"
import style0 from "./ModelliEmail.vue?vue&type=style&index=0&id=7c9c18e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c9c18e4",
  null
  
)

export default component.exports